export default "__VITE_ASSET__41a24f12__"